import { Database } from '@phosphor-icons/react';

export default Database;
